export const AccessControlIcon = () => {
  return (
    <svg
      width="30"
      height="33"
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9286 1.60599L16.7242 0.857643C10.3152 -0.658247 6.49669 0.589004 4.25164 5.23262C3.67599 6.40311 3.21547 7.82306 2.8317 9.45408L0.951224 17.4941C-0.929247 25.5148 1.54607 29.4677 9.54766 31.3673L12.7713 32.1349C13.8843 32.4035 14.9204 32.5762 15.8799 32.653C21.8667 33.2286 25.052 30.4271 26.6638 23.5001L28.5443 15.4793C30.4247 7.45848 27.9686 3.48646 19.9286 1.60599ZM16.3212 21.0247C16.1485 21.6771 15.5728 22.0993 14.9204 22.0993C14.8053 22.0993 14.6902 22.0801 14.5559 22.0609L8.97201 20.641C8.20447 20.4491 7.74395 19.6624 7.93583 18.8948C8.12772 18.1273 8.91444 17.6668 9.68198 17.8586L15.2658 19.2786C16.0526 19.4705 16.5131 20.2572 16.3212 21.0247ZM21.9434 14.539C21.7707 15.1914 21.1951 15.6136 20.5427 15.6136C20.4275 15.6136 20.3124 15.5944 20.1781 15.5752L10.8717 13.215C10.1041 13.0231 9.64361 12.2364 9.83549 11.4689C10.0274 10.7013 10.8141 10.2408 11.5816 10.4327L20.8881 12.7929C21.6748 12.9656 22.1353 13.7523 21.9434 14.539Z"
        fill="url(#paint0_linear_1444_19337)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1444_19337"
          x1="0.353637"
          y1="24.5789"
          x2="28.8536"
          y2="8.07893"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#34544F" />
          <stop offset="1" stopColor="#5E978E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
